import cloneDeep from "clone-deep";
import { getDefaultOption } from "../../../../helpers/forms/select.js";
const checkIfMustUpdateSelectedOptions = (passenger)=>!passenger?.options?.length || passenger?.selectedOptions?.length === passenger.value;
export const updateSelectedOptions = (value)=>{
    const passengerKeys = Object.keys(value).filter((key)=>key !== 'title').map((key)=>key);
    const newValue = cloneDeep(value);
    for (const passengerKey of passengerKeys){
        if (!newValue[passengerKey]) continue;
        const passenger = newValue[passengerKey];
        if (checkIfMustUpdateSelectedOptions(passenger)) continue;
        if (!passenger.selectedOptions) passenger.selectedOptions = [];
        const defaultSelectedOption = getDefaultOption(passenger.options);
        if (!defaultSelectedOption) continue;
        if (passenger.selectedOptions.length < passenger.value) {
            for(let i = passenger.selectedOptions.length; i < passenger.value; i++){
                passenger.selectedOptions.push(defaultSelectedOption.value);
            }
        } else {
            passenger.selectedOptions = passenger.selectedOptions.slice(0, passenger.value);
        }
    }
    return newValue;
};

//# sourceMappingURL=utils.js.map